<template>
  <div>
    <audio
      v-if="media.type == 'audio'"
      :src="media.url"
      controls
    />
    <video
      v-if="media.type == 'video'"
      :src="media.url"
      controls
    />
  </div>
</template>

<script>
export default {
  name: 'Media',

  props: {
    media: {
      type: Object,
    }
  }
}
</script>
